import { COLORS } from '@/styles/colors';
import { flexCenter } from '@/styles/layout';
import { body, caption, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const Avatar = styled.button`
  ${flexCenter};
  border-radius: 100%;
  width: 40px;
  height: 40px;
  background-color: ${COLORS.black};
  color: ${COLORS.white};
  cursor: pointer;
  ${poppinsMediumFont};
  outline: none;
  border: none;
  ${body};
`;

export const UserType = styled.div`
  display: inline-block;
  padding: 4px 10px;
  background-color: ${COLORS.green[500]};
  border-radius: 6px;
  color: ${COLORS.white};
  ${caption};
  ${poppinsMediumFont};
`;
